import React from 'react'
import { useForm } from 'react-hook-form'
import CrudEdit from '~/components/CrudEdit'
import IWorkShift from '../interfaces/IWorkShift'

export default function Edit() {
  const {
    register,
    handleSubmit,
    control,
    setValue: setFormValue,
    getValues,
  } = useForm<IWorkShift>({})

  const fields = [
    { name: 'id', type: 'hidden' },
    { name: 'name', type: 'string', required: true },
    { name: 'work_hours',  placeholder: 'work_hours', type: 'number', required: true },
    { name: 'rest_hours', placeholder: 'rest_hours', type: 'number', required: true },
  ]

  return (
    <CrudEdit
      model={'work-shift'}
      fields={fields}
      register={register}
      handleSubmit={handleSubmit}
      control={control}
      setFormValue={setFormValue}
      messageSuccess={'Work shift successfully updated!'}
      title={'Edit Work Shift'}
      getValues={getValues}
    />
  )
}
